import { ApiError } from '../../identity/types';
import { friendlyErrorMessage } from '../../../shared/friendlyError';

/**
 * Error copy for the Partner Portal. The shared `friendlyErrorMessage` turns every 409 into "may already have been done", which would hide the Partner API's own answers ("A partner firm must keep
 * at least one active Partner Owner", "Only an invitation that has not been answered can be re-sent"). Those 400 and 409 messages are written by the API for exactly this purpose and carry no
 * internal detail, so they are shown as they are. Everything else (401, 403, 5xx, network) keeps the shared safe wording, and a message that is only the client's fallback ("Request to /api/...")
 * is never shown. A 403 the API authored in words ("You cannot open this client.") is shown too, unless it carries a stable code (a subscription state, MFA), which the shared wording and the screens handle.
 */
export function partnerErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError && (error.status === 400 || error.status === 409) && error.message && !error.message.startsWith('Request to ')) {
    return error.message;
  }

  if (error instanceof ApiError && error.status === 403 && error.code === null && error.messageIsServerAuthored && error.message && !error.message.startsWith('Request to ')) {
    return error.message;
  }

  return friendlyErrorMessage(error, fallback);
}
